import * as ActionTypes from 'app/common/constants/action-types';

export const INITIAL_STATE = {
  keyword: '',
  keywordForSuggestions: '',
  locationSuggestion: null,
};

function prefillLocation(state, action) {
  const { locationSuggestion, isRecent } = action;
  const { address } = locationSuggestion || {};
  const keyword = address || '';
  const keywordForSuggestions = isRecent ? '' : state.keyword;
  return {
    ...state,
    keywordForSuggestions,
    keyword,
    locationSuggestion,
  };
}

function locationSuggestionsReducer(state = INITIAL_STATE, action) {
  const { type, keyword } = action;
  switch (type) {
    case ActionTypes.UPDATE_LOCATION_SEARCH_KEYWORD:
      return {
        ...state,
        keyword,
        keywordForSuggestions: keyword,
        locationSuggestion: null,
      };
    case ActionTypes.REST_SEARCH_KEYWORDS:
      return {
        ...state,
        keyword: '',
        keywordForSuggestions: '',
        locationSuggestion: null,
      };
    case ActionTypes.SEARCH_PREFILL_LOCATION:
      return prefillLocation(state, action);
    default:
      return state;
  }
}

export default locationSuggestionsReducer;
